module.exports = __webpack_public_path__ + "media/images/linkedin-1-994f9a2a1f1f0b163e64cb666bdd2f32.png";